import React, { Fragment, useEffect, useRef, useState } from 'react'
import { Carousel } from 'antd'
import Image from 'next/image'
import { Icon } from '@iconify/react'
import { useTranslation } from 'src/utils/i18n'
import NewFooter from 'src/components/android-step/newFooter'
import { styled } from '@mui/material'

const ScrollDiv = styled('div')({
  '@media (max-width: 600px)': {
    '-msOverflowStyle': 'none',  /* 适用于 IE 和 Edge */
    scrollbarWidth: 'none',  /* 适用于 Firefox */
    '&::-webkit-scrollbar': {
      display: 'none', /* 适用于 WebKit 浏览器（如 Chrome、Safari 和新版 Edge） */
    }
  }
})

function One(data) {
  const { t } = useTranslation('commonAndroid')

  const step = [
    {
      title: t(
        "<div style='display: inline-block;line-height: 20px;'>Go to the <p style='font-weight: 600;margin-left: 5px;display: inline-block;'>Play Store</p>.</div>"
      ),
      img: '/images/android/one/1.png'
    },
    {
      title: t(
        "<div style='display: inline-block;line-height: 20px;'>Tap on<p style='font-weight: 600;margin-left: 5px;display: inline-block;'>the profile icon</p><p style='display: inline-block;margin: 0 5px;'>or</p><p style='display: inline-block;font-weight: 600;margin-right: 5px;'>the three dots</p>in the top right corner. </div>"
      ),
      img: '/images/android/one/2.png'
    },
    {
      title: t(
        "<div style='display: inline-block;line-height: 20px;'>Find and tap <p style='font-weight: 600;margin-left: 5px;display: inline-block;'>Play Protect</p>.</div>"
      ),
      img: '/images/android/one/3.png'
    },
    {
      title: t(
        "<div style='display: inline-block;line-height: 20px;'>Tap on<p style='font-weight: 600;margin:0px 5px;display: inline-block;'>Settings</p>(gear icon) in the top right corner.</div>"
      ),
      img: '/images/android/one/4.png'
    },
    {
      title: t(
        "<div style='display: inline-block;line-height: 20px;'>Turn off<p style='font-weight: 600;margin-left: 5px;display: inline-block;'>Scan apps with Play Protect</p>.</div>"
      ),
      img: '/images/android/one/5.png'
    },
    {
      title: t(
        "<div style='display: inline-block;line-height: 20px;'>Tap<p style='font-weight: 600;margin:0px 5px;display: inline-block;'>Turn off</p> in pop-up.</div>"
      ),
      img: '/images/android/one/6.png'
    }
  ]

  const imgToggle = useRef()

  const [currentSlide, setcurrentSlide] = useState(0)

  const onChange = currentSlide1 => {
    setcurrentSlide(currentSlide1)
  }

  const Handler = index => {
    if (index !== 6) {
      imgToggle.current.goTo(index)
    } else {
      imgToggle.current.goTo(0)
    }
  }

  const [autoplay, setAutoplay] = useState(true)

  useEffect(() => {
    const handleClick = event => {
      if (window.innerWidth < 600) {
        setAutoplay(false)

        setTimeout(() => {
          setAutoplay(true)
        }, [5000])
      }
    }

    // 添加点击事件监听器
    document.addEventListener('click', handleClick)

    // 添加滑动事件监听器
    document.addEventListener('scroll', handleClick)

    // 在组件卸载时移除事件监听器
    return () => {
      document.removeEventListener('click', handleClick)
      document.removeEventListener('scroll', handleClick)
    }
  }, [autoplay]) // 空数组表示只在组件加载和卸载时运行

  const StepProgress = ({ current = 1, total = 6 }) => {
    const barWidth = 72 // 宽度

    return (
      <div className="flex items-center justify-center gap-4 mb-[40px] Mlg:mb-[20px]">
        <div className="text-[20px] leading-[30px] font-medium text-[#484B60] Mlg:text-[16px] Mlg:leading-[24px] ">
          {current}/{total}
        </div>

        <div className="flex gap-x-[6px]">
          {Array.from({ length: total }).map((_, i) => {
            const active = i < current;

            return (
              <div
                key={i}
                className="h-[4px] w-[72px] Mlg:w-[42.17px] rounded-[1px]"
                style={
                  active
                    ? {
                      background: "linear-gradient(90deg, #09A6EA 1.56%, #6838F2 47.99%)",
                      backgroundSize: `${current * barWidth}px 4px`,
                      backgroundPosition: `-${i * barWidth}px 0px`,
                    }
                    : {
                      background: "#E8EDFF",
                    }
                }
              />
            )
          })}
        </div>
      </div>
    )
  }

  return (

    <Fragment>
      <StepProgress />
      <ScrollDiv
        className={`w-[620px] Ssm:w-[100%] mx-auto overflow-x-hidden justify-between setup ${data.fullScreen ? 'flex justify-center xs:pb-[10px]' : ' Smd:flex xs:pb-[70px] h-[99%]'
          } overflow-auto pb-[88px] h-full p-[0px_15px_15px_15px] max-w-[1440px]`}
      >
        {data.fullScreen && (
          <Icon
            onClick={() => {
              data.setFullScreen(false)
            }}
            icon='maki:cross'
            className={`absolute top-2 right-3 w-[20px] h-[20px] text-black/30`}
          />
        )}

        <div
          className={`Ssm:w-[100%] w-full mx-auto setup ${data.fullScreen ? 'grid mx-auto h-full justify-center' : 'Smd:flex Dsm:mt-[0px] justify-between'
            }`}
        >
          <div
            className={`w-[343px] ${data.fullScreen ? 'order-2 w-[80%] mx-auto' : 'Dsm:w-[100%] Ssm:mx-auto'
              }`}
          >
            <p
              className={`text-[24px] Dsm:text-[20px] pb-[10px] font-[600] text-[#2B2D33] Dsm:text-center  ${data.fullScreen ? 'hidden' : ''
                }`}
            >
              {t("Disable Play Protect on the device you want to monitor")}
            </p>
            <div
              onMouseEnter={() => {
                if (window.innerWidth > 600) {
                  setAutoplay(false)
                }
              }}
              onMouseLeave={() => {
                if (window.innerWidth > 600) {
                  setAutoplay(true)
                }
              }}
              className={`pl-1 ${data.fullScreen ? 'pt-[20px]' : 'Dsm:pt-[5px] Dsm:w-[96%] mx-auto pt-[5px]'}`}
            >
              {step.map((item, index) => {
                return (
                  <div
                    onClick={() => Handler(index)}
                    key={index}
                    className={`flex text-[14px] cursor-pointer text-black ${data.fullScreen ? 'mt-[10px]' : ' mt-[7px] Dsm:mt-[10px]'
                      }`}
                  >
                    <p
                      className={`w-[24px] h-[22px] rounded-full flex items-center justify-center mt-[2px] ${currentSlide === index && 'bg-[#2A99FF] text-white'
                        }`}
                    >
                      {index + 1}.
                    </p>
                    <div
                      className={`ml-1 w-[100%] mt-[2px] ${data.fullScreen ? 'text-[15px]' : 'text-[15px]'}`}
                      dangerouslySetInnerHTML={{ __html: item.title }}
                    />
                  </div>
                )
              })}
            </div>
            <div className={`bg-white p-3 mt-6 flex items-start rounded-[8px] [box-shadow:0px_1px_6px_0px_#28293826] ${data.fullScreen && 'mb-[138px]'}`}>
              <Image src={'/warn.svg'} width={24} height={24} alt='' />
              <p className='ml-3 text-[14px] leading-[22px] text-[#282938]'>
                {t('The app comes from the trusted developer but Google Play may temporarily block it for universal protection Please disable this setting to install the app smoothly')}
              </p>
            </div>
          </div>
          <div
            className={`w-[221px] h-[506px] rounded-[24px] p-[6px] border-[1px] relative border-[#ACB1BD] ${data.fullScreen ? 'order-1 mx-auto' : 'Ssm:hidden'
              }`}
          >
            <Carousel
              waitForAnimate={true}
              autoplay={autoplay}
              className='flex rounded-[15px] border-[#ACB1BD] overflow-hidden border-[1px] w-[207px] h-[449px]'
              ref={imgToggle}
              cancelable={false}
              afterChange={onChange}
            >
              {step.map((item, index) => {
                return (
                  <div key={index} className=''>
                    <Image
                      alt='img'
                      width={100}
                      height={100}
                      src={item.img}
                      className='mx-auto w-[207px] h-[447px] rounded-[15px]'
                    />
                  </div>
                )
              })}
            </Carousel>
            <div className='flex items-center justify-center mt-5'>
              {step.map((item, index) => {
                return (
                  <div
                    onClick={() => Handler(index)}
                    key={index}
                    className={`border-[1px] ${index !== 0 && 'ml-2'
                      } border-[#2A99FF] w-[12px] h-[12px] cursor-pointer rounded-[15px] ${currentSlide === index && 'bg-[#2A99FF]'
                      } `}
                  ></div>
                )
              })}
            </div>
            <div className='absolute -left-[4px] top-[55px]'>
              <Image src='/images/android/1.svg' className='w-[5px] h-[24px]' width={100} height={100} alt='img' />
              <Image src='/images/android/1.svg' className='w-[5px] h-[24px] mt-4' width={100} height={100} alt='img' />
            </div>
          </div>
        </div>

        <div className={`flex flex-col items-center Smd:hidden ${data.fullScreen && 'hidden'} mb-[65px]`} onClick={() => data.setFullScreen(true)}>
          <Image
            src='/images/bind/watch.svg'
            width={100}
            height={100}
            alt='img'
            className='mx-auto w-[58px] mt-[36px]'
          />
          <p className='mt-[14px] text-[14px] text-[#454CFF] font-[600]'>{t('Watch a tutorial')}</p>
        </div>

      </ScrollDiv>

      <NewFooter nowPage={data.nowPage} setNowPage={data.setNowPage} startMonitoring={data.startMonitoring} />
    </Fragment>
  )
}

export default One
